import script from "./InputAtom.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputAtom.vue?vue&type=script&setup=true&lang=ts"

import "./InputAtom.vue?vue&type=style&index=0&id=88b128fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88b128fc"]])

export default __exports__